export const iconFontAwesomeMedicalHealthPills = (
	<i className="fa-solid fa-pills"></i>
);
